import { WMS_FA_PEMBELIAN } from "App/constants";
import { isNull } from "App/utils/helpers";
import React, { createContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { FORM_RESET_STATE_WMS_PEMBELIAN } from "../helpers";

export const FormContext = createContext();

export const FormProvider = ({ data, children, menu }) => {
  const oldFormData = useRef(null);
  const stateRedux = useSelector((state) => state);
  const setting = stateRedux.setting;
  const KAS = setting.default_kas;
  const GD_FA = setting.default_gudang_fa;

  const [formData, setFormData] = useState(() => {
    if (isNull(data)) {
      return {...FORM_RESET_STATE_WMS_PEMBELIAN,
        kasbank_id: KAS.kas_id,
        kasbank: KAS.kas_nama,
        coa_code: KAS.coa_code,
        gudang_id: GD_FA.gudang_id,
        gudang: GD_FA.gudang,
      };
    } else {
      if (menu === WMS_FA_PEMBELIAN) {
        oldFormData.current = data;
        return data;
      } else {
        if (isNull(oldFormData.current)) {
          return {...FORM_RESET_STATE_WMS_PEMBELIAN,
            kasbank_id: KAS.kas_id,
            kasbank: KAS.kas_nama,
            coa_code: KAS.coa_code,
            gudang_id: GD_FA.gudang_id,
            gudang: GD_FA.gudang,
          };
        } else {
          return oldFormData.current;
        }
      }
    }
  });

  useEffect(() => {
    if (isNull(data)) {
      setFormData({...FORM_RESET_STATE_WMS_PEMBELIAN,
        kasbank_id: KAS.kas_id,
        kasbank: KAS.kas_nama,
        coa_code: KAS.coa_code,
        gudang_id: GD_FA.gudang_id,
        gudang: GD_FA.gudang,
      });
    } else {
      if (menu === WMS_FA_PEMBELIAN) {
        oldFormData.current = data;
        setFormData(data);
      } else {
        if (isNull(oldFormData.current)) {
          setFormData({...FORM_RESET_STATE_WMS_PEMBELIAN,
            kasbank_id: KAS.kas_id,
            kasbank: KAS.kas_nama,
            coa_code: KAS.coa_code,
            gudang_id: GD_FA.gudang_id,
            gudang: GD_FA.gudang,
          });
        } else {
          setFormData(oldFormData.current);
        }
      }
    }
  }, [data]); // eslint-disable-line

  const [totalJumlah, setTotalJumlah] = useState([
    {
      totalJumlah:0,
      totalLain:0,
      subTotalDisBarang:0,
    }
  ]);

  return (
    <FormContext.Provider
      value={{ formData, setFormData, totalJumlah, setTotalJumlah, KAS, GD_FA }}>
      {children}
    </FormContext.Provider>
  );
};
